import * as Yup from 'yup';
import { VEHICLE_REGISTRATION_REGEX } from '@acorn-portal/shared/src/utils/constants/Regex';
import { VEHICLE_DETAILS_PART_ONE_ERROR_MESSAGES } from '@acorn-portal/shared/src/utils/constants/ErrorMessages';

export const amendVehiclePart1Schema = Yup.object().shape({
	vrm: Yup.string()
		.required(VEHICLE_DETAILS_PART_ONE_ERROR_MESSAGES.registrationRequired)
		.matches(VEHICLE_REGISTRATION_REGEX, VEHICLE_DETAILS_PART_ONE_ERROR_MESSAGES.validRegistration),
});
